// @ts-check
import React from 'react';
import _ from 'lodash';
import { contentfulModels } from '@glowforge/ui-common';
import MaterialsCarousel3d from './materials-carousel-3d';

const { widgetDefaultProps, widgetPropType } = contentfulModels;
const { getSectionForPageByIdAndType } = contentfulModels;

/**
 * @typedef {object} Props
 * @property {{ fields: {id: string, text: string }[] }[]} textStrings
 * @property {{ fields: {title: string, text: string }[] }[]} sections
 */

/**
 * MaterialsCarousel3d Contentful accessor widget.
 * Maps Contentful data to the Carousel3d component.
 * @class
 * @extends {React.PureComponent<Props>}
 */
class MaterialsCarousel3dWidget extends React.PureComponent {
  render() {
    const {
      sections = [],
      textStrings = [],
    } = this.props;

    const ctaProps = getSectionForPageByIdAndType(
      { sections },
      'materials-carousel-3d-learn-more-button-link',
      'buttonLink',
    ) || {};

    const galleryData = getSectionForPageByIdAndType(
      { sections },
      'materials-carousel-3d-gallery-items',
      'list',
    ) || [];

    /**
     * @param {string} id Text field id
     */
    const getTextById = (id) => {
      if (!textStrings) { return ''; }
      const item = textStrings.find(i => _.get(i, 'fields.id') === id);
      return _.get(item, 'fields.text', '');
    };

    const title = getTextById('materials-carousel-3d-title');
    const text = getTextById('materials-carousel-3d-text');

    const items = _.get(galleryData, 'listItems').map(({ fields }) => ({
      id: _.get(fields, 'id'),
      thumbnailTitle: _.get(fields, 'title', ''),
      thumbnailUrl: `${_.get(fields, 'listItems[0].fields.media.fields.file.url', '')}?w=160&h=160`,
      heroUrl: `${_.get(fields, 'listItems[1].fields.media.fields.file.url', '')}?fm=jpg&fl=progressive`,
      heroPlaceholderUrl: `${_.get(fields, 'listItems[1].fields.media.fields.file.url', '')}?q=1&fm=jpg&fl=progressive`,
      description: _.get(fields, 'text', ''),
    }));

    return (
      <MaterialsCarousel3d
        data={items}
        ctaProps={ctaProps}
        title={title}
        text={text} />
    );
  }
}

MaterialsCarousel3dWidget.propTypes = { ...widgetPropType };

MaterialsCarousel3dWidget.defaultProps = { ...widgetDefaultProps };

export default MaterialsCarousel3dWidget;




// WEBPACK FOOTER //
// ./app/components/landing/materials-carousel-3d-widget.jsx